export const FieldValidationTestIdFactory = {
    getFieldValidationBase: () => 'field-validation',
    getFieldValidationClientErrorBase: () => 'client-error',
    // test id generators
    getFieldValidationContainerTestId: (testId) => [FieldValidationTestIdFactory.getFieldValidationBase(), testId].join('-'),
};
